import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The categories anagrafica: the first screen of the championship register. Reached from
// `/leagues`, which owns the menu entry.

export const leagueCategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/leagues/categories',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/league-categories.tsx')),
})

export const leagueCategoriesLink = { to: '/leagues/categories' } as const
